import { useQuery } from 'react-query';

import { getSmartMultiTraps } from 'api/traps/MultiCatchTrap/getSmartMultiTraps';

export const useGetSmartMultiTraps = (slug: string, enabled: boolean = true) => {
  const { data, refetch, isLoading } = useQuery('smartMultiTraps', () => getSmartMultiTraps(slug), {
    enabled,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });

  return { data, refetch, isLoading };
};

export default useGetSmartMultiTraps;
